module.exports = __webpack_public_path__ + "img/12.2ec86d61.jpg";